<h2 class="dialog-title">
  <ng-content></ng-content>
</h2>

<button
  appButtonIcon
  size="medium"
  class="dialog-close-button"
  (click)="closeDialog()"
>
  <svg icon="cancel" />
</button>
